export default "__VITE_ASSET__CWKL5EZt__"